import { parse, stringify } from 'flatted'

export function createStorePersistence ({ storage, key, store }) {
  try {
    const fromStorage = storage.getItem(key)
    if (fromStorage) {
      store.$patch(parse(fromStorage))
    }
  } catch (e) {
    console.log('Store init failed: ', e)
  }

  const persist = () => {
    try {
      storage.setItem(key, stringify(store.$state))
    } catch (e) {
      console.log('Store persist failed: ', e)
    }
  }

  store.$subscribe(persist, { detached: true })

  // $subscribe flushes on the scheduler, so callers that mutate while the page is being
  // torn down (unload) must flush themselves.
  return persist
}
